import { GuardianinfoService } from "./../shell/forms/school-management/Admission/guardianinfo/guardianinfo.service";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

import { LoginComponent } from "./login.component";

import { LoginRoutingModule } from "./login-routing.module";
import { EmployeeinfohdrService } from "../shell/forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service";
import { ComponentModule } from "../components/component.module";

@NgModule({
  imports: [CommonModule, FormsModule, LoginRoutingModule, ComponentModule],
  declarations: [LoginComponent],
  providers: [
    
  ]
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts